import React from 'react'
import { Route } from 'react-router-dom'
import { lazyRoute } from './lazy-route'

const Settings = React.lazy(() => import('@/pages/settings/Settings'))
const SettingsCompany = React.lazy(() => import('@/pages/settings/Company'))
const SettingsUsers = React.lazy(() => import('@/pages/settings/UserManagement'))
const SettingsTheme = React.lazy(() => import('@/pages/settings/ThemeSettings'))

export function renderSettingsRoutes(): React.ReactElement {
  return (
    <>
      <Route path="settings" element={lazyRoute(Settings, 'Loading settings...')} />
      <Route path="settings/company" element={lazyRoute(SettingsCompany, 'Loading company settings...')} />
      <Route path="settings/users" element={lazyRoute(SettingsUsers, 'Loading users & roles...')} />
      <Route path="settings/theme" element={lazyRoute(SettingsTheme, 'Loading theme settings...')} />
    </>
  )
}
